export default __webpack_public_path__ + "static/media/caution-icon.21a2d040.svg";